// extracted by mini-css-extract-plugin
export default {"heading":"sector_heading__llkoy","sectors":"sector_sectors__6Xom2","sub_text":"sector_sub_text__U2Qd-","iconState":"sector_iconState__27E4d","imageIcon":"sector_imageIcon__ImAw4"};